import { useEffect, useState } from "react";
import { useLang } from "../i18n";

const KEY = "bt_cookie_consent";

export const CookieConsent = () => {
  const { t } = useLang();
  const [state, setState] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
  });
  const [customising, setCustomising] = useState(false);
  const [prefs, setPrefs] = useState({ analytics: false, marketing: false });
  const [forceOpen, setForceOpen] = useState(false);

  useEffect(() => {
    const open = () => setForceOpen(true);
    window.addEventListener("bt-open-cookies", open);
    return () => window.removeEventListener("bt-open-cookies", open);
  }, []);

  const save = (value) => {
    const v = { essential: true, ...value, date: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(v));
    setState(v); setForceOpen(false); setCustomising(false);
  };

  const visible = !state || forceOpen;
  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[70] p-4 sm:p-6" data-testid="cookie-banner" role="dialog" aria-label={t.cookiesBanner.title}>
      <div className="max-w-3xl mx-auto bg-[#101214] border border-white/12 rounded-2xl shadow-2xl p-5 sm:p-6">
        <h2 className="text-white font-black text-base">{t.cookiesBanner.title}</h2>
        <p className="mt-2 text-sm text-white/60 leading-relaxed">{t.cookiesBanner.text}</p>

        {customising && (
          <div className="mt-4 space-y-3 text-sm text-white/75">
            <label className="flex items-center gap-3">
              <input type="checkbox" checked disabled className="accent-[#FF6600] w-4 h-4" /> {t.cookiesBanner.essential}
            </label>
            <label className="flex items-center gap-3">
              <input type="checkbox" className="accent-[#FF6600] w-4 h-4" checked={prefs.analytics}
                onChange={(e) => setPrefs({ ...prefs, analytics: e.target.checked })} data-testid="cookie-analytics-toggle" /> {t.cookiesBanner.analytics}
            </label>
            <label className="flex items-center gap-3">
              <input type="checkbox" className="accent-[#FF6600] w-4 h-4" checked={prefs.marketing}
                onChange={(e) => setPrefs({ ...prefs, marketing: e.target.checked })} data-testid="cookie-marketing-toggle" /> {t.cookiesBanner.marketing}
            </label>
          </div>
        )}

        <div className="mt-5 flex flex-wrap gap-2.5">
          {customising ? (
            <button onClick={() => save(prefs)} data-testid="cookie-save"
              className="bg-[#FF6600] hover:bg-[#FF9900] text-[#08090A] text-xs font-black rounded-full px-5 py-2.5 transition-colors">{t.cookiesBanner.save}</button>
          ) : (
            <>
              <button onClick={() => save({ analytics: true, marketing: true })} data-testid="cookie-accept"
                className="bg-[#FF6600] hover:bg-[#FF9900] text-[#08090A] text-xs font-black rounded-full px-5 py-2.5 transition-colors">{t.cookiesBanner.accept}</button>
              <button onClick={() => save({ analytics: false, marketing: false })} data-testid="cookie-reject"
                className="border border-white/20 text-white text-xs font-bold rounded-full px-5 py-2.5 hover:border-[#FF6600] transition-colors">{t.cookiesBanner.reject}</button>
              <button onClick={() => setCustomising(true)} data-testid="cookie-customize"
                className="text-white/60 hover:text-[#FF9900] text-xs font-bold rounded-full px-4 py-2.5 transition-colors">{t.cookiesBanner.customize}</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
